
const state = {
  message: {
    viewProduct: [],
    show: false,
    body: {}
  },
  inputData: {
    system: {
      typ: '',
      kamery: true,
      nvr: false,
      nvrMiejsce: false,
      nvrSzerokosc: 0,
      nvrWysokosc: 0,
      nvrGlebokosc: 0
    },
    kamera: {
      ilosc: 0,
      moce: [],
      mocSumaryczna: 0,
      mocWybrana: null
    },
    nvr: {
      moc: 0,
      szerokosc: 0,
      wysokosc: 0,
      glebokosc: 0
    },
    podtrzymanie: {
      rodzaj: '',
      starzenie: false,
      ah: '',
      ahTab: [],
      czas: '00:00',
      czasTab: []
    },
    paramsSwitch: {
      'mocPortu': 0,
      'mocSumaryczna': 0,
      'mocPoboru': 0,
      'szerokosc': 0,
      'wysokosc': 0,
      'glebokosc': 0
    },

    indexSwitch: null,
    indexSystem: null
    // rowIndex: null,
    // itemIndex: null,
    // elementIndex: null,
    // switchId: null,

    // systemTyp: '',
    // systemNVR: false,
    // ports: [],
    // cameras: [],
    // camerasPowers: [],
    // totalPower: []

  }
}

const getters = {
  message: state => state.message,
  viewProduct: state => state.viewProduct,
  inputData: state => state.inputData
}

const actions = {
  reset ({commit}) {
    commit('RESET')
  }
}

const mutations = {

  SET_MESSAGE (state, response) {
    state.message = {
      show: true,
      body: response.data.message
    }
  },

  SET_VIEW_PRODUCT (state, payload) {
    state.viewProduct = []
    state.viewProduct.push(payload)
  },

  SET_INPUT_DATA_ARRAY (state, payload) {
    var data = Object.assign({}, payload[1])
    state.inputData[payload[0]] = data
  },
  SET_INPUT_DATA_VALUE (state, payload) {
    state.inputData[payload[0]] = payload[1]
  },

  CLEAR_INPUTS_DATA (state, payload) {
    payload.forEach(element => {
      if (Array.isArray(state.inputData[element])) { state.inputData[element] = [] } else {
        state.inputData[element] = null
      }
    })
  },

  CLEAR_INPUTDATA (state) {
    state.inputData = {
      system: {
        typ: '',
        kamery: true,
        nvr: false,
        nvrMiejsce: false,
        nvrSzerokosc: 0,
        nvrWysokosc: 0,
        nvrGlebokosc: 0
      },
      kamera: {
        ilosc: 0,
        moce: [],
        mocSumaryczna: 0,
        mocWybrana: null
      },
      nvr: {
        moc: 0,
        szerokosc: 0,
        wysokosc: 0,
        glebokosc: 0
      },
      podtrzymanie: {
        rodzaj: '',
        starzenie: false,
        ah: '',
        ahTab: [],
        czas: '00:00',
        czasTab: []
      },
      paramsSwitch: {
        'mocPortu': 0,
        'mocSumaryczna': 0,
        'mocPoboru': 0,
        'szerokosc': 0,
        'wysokosc': 0,
        'glebokosc': 0
      },

      indexSwitch: null,
      indexSystem: null
    }
  },

  CLEAR_INPUTDATA_PODTRZYMANIE (state) {
    state.inputData.podtrzymanie = {
      rodzaj: '',
      starzenie: false,
      ah: '',
      ahTab: [],
      czas: '00:00',
      czasTab: []
    }
  },

  CLEAR_INPUTDATA_KAMERA (state) {
    state.inputData.kamera = {
      ilosc: 0,
      moce: [],
      mocSumaryczna: 0,
      mocWybrana: null
    }
  },
  CLEAR_INPUTDATA_NVR (state) {
    state.inputData.nvr = {
      moc: 0,
      szerokosc: 0,
      wysokosc: 0,
      glebokosc: 0
    }
  },

  RESET (state) {
    state.message = {
      show: false,
      body: {}
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js